export const addDotBtnsAndClickHandlers = (embla, dotsNode) => {
    const slideCount = embla.slideNodes().length
    const dotButtons = []

    const createDot = (index) => {
        const btn = document.createElement('button')
        btn.classList.add('mina__dot')
        btn.type = 'button'
        btn.addEventListener('click', () => embla.scrollTo(index))
        dotsNode.appendChild(btn)
        dotButtons.push(btn)
    }

    for (let i = 0; i < slideCount; i++) createDot(i)

    const updateSelectedDot = () => {
        const selectedIndex = embla.selectedScrollSnap()
        dotButtons.forEach((btn, i) => {
            btn.classList.toggle('mina__dot--selected', i === selectedIndex)
        })
    }

    embla.on('select', updateSelectedDot)
    embla.on('init', updateSelectedDot)
}
